<template>
      <v-parallax
    dark
    src="./header.jpg"
    position="25% center"
  >
    <v-layout
      align-center
      column
      justify-center
    >
      <h1 class="display-2 font-weight-thin mb-3">Arlon Antonius</h1>
      <h4 class="subheading">Complex development made easy!</h4>
    </v-layout>
    <v-layout align-center justify-center row>
      <v-flex xs2 align-center justify-center>
        <v-layout>
          <v-flex>
            <a v-if="this.info.github" :href="this.info.github">
              <v-icon color='white' size="3em">
                fab fa-github
              </v-icon>
            </a>
          </v-flex>
          <v-flex>
            <a v-if="this.info.twitter" :href="this.info.twitter">
              <v-icon color='white' size="3em">
                fab fa-twitter
              </v-icon>
            </a>
          </v-flex>
          <v-flex>
            <a v-if="this.info.facebook" :href="this.info.facebook">
              <v-icon color='white' size="3em">
                fab fa-facebook
              </v-icon>
            </a>
          </v-flex>
          
          <v-flex>
            <a v-if="this.info.email" :href="this.getEmail()">
              <v-icon color='white' size="3em">
                fa fa-envelope
              </v-icon>
            </a>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-parallax>
</template>

<script>
export default {
    name: 'Header',
    props: [
      'info'
    ],
    methods: {
      getEmail(){
        return "mailto:" + this.info.email
      }
    }
}
</script>

<style scoped>

</style>
